import React, {useState} from 'react';

import {ListMenu} from 'components/items';
import ic_left from 'image/ic_left.svg';
import firebase from 'library/firebase-config.js';
import 'firebase/auth';
const auth = firebase.auth();


const menuArr = [
  {
    id: "admin-menu-home",
    gnb: {name: "home", link: '/admin/home'},
    lnb: null
  },{
    id: "admin-menu-about",
    gnb: {name: "about us", link: '/admin/about'},
    lnb: null
  },{
    id: "admin-menu-portfolio",
    gnb: {name: "portfolio", link: "/admin/portfolio"},
    lnb: null
  },{
    id: "admin-menu-recruit",
    gnb: {name: "recruit", link: '/admin/recruit/staff'},
    lnb: null
  },{
    id: "admin-menu-customer",
    gnb: {name: "customer center", link: '/admin/customer/faq'},
    lnb: null
  }]

const AdminMenu = (props) => {

  const [isLnbClicked, setLnb] = useState(false);
  const [nowLnb, setNowLnb] = useState();

  const handleLogout = ()=> {
    console.log('test')
    props.setMenu(false);
    auth.signOut();
	}
  
  const menuToggle = () => {
    console.log('-menuToggle-');
    setLnb(!isLnbClicked);
    setNowLnb(null);
  }
 
  const lnbClickHandler = (e) => {
    console.log('-lnbClickHandler-');
    menuToggle();
    setNowLnb(e.target.id);
  }

  const drawMenu = () => {
    return menuArr.map(el => {
      let active = false;
      if(el.id === nowLnb) active = true;
      return <ListMenu 
                key = {el.id} 
                items = {el} 
                lnbClickHandler = {lnbClickHandler} 
                active = {active} 
                setMenu = {props.setMenu} 
                isMenuClicked = {props.isMenuClicked}
              />
    })
  }


  return (
    <section className={props.isMenuClicked ? "wrap-menu menu-show" : "wrap-menu"}>
      <div className="con">
        <div className={isLnbClicked ? "btn-menu-back backBtn-show" : "btn-menu-back"}  onClick={menuToggle}><img src={ic_left} alt="left"/></div>

        <ul className= {isLnbClicked ? " header-gnb-mobile font-gnb show-lnb" : "header-gnb-mobile font-gnb"}>

          {drawMenu()}

        </ul>
        
        <div className="btn-shop-mobile font-gnb" onClick = {handleLogout}>
          <p>log out</p>
        </div>

      </div>
    </section>
  );
}

export default AdminMenu;